<template>
  <div class="d-flex w-100 d-block bg-white p-1">
    <div class="position-relative ml-3 mr-3">
      <span :class="iconClass" v-html="setIcon"></span>
    </div>
    <div class="h6 mb-0">
      <p class="mb-0 msg-style" v-html="message"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comparison-message',
  props: {
    iconName: {},
    iconClass: {},
    message: {},
  },
  computed: {
    setIcon() {
      return '<i class="' + this.iconName + '"></i>'
    },
  },
}
</script>

<style lang="scss" scoped>
.msg-style {
  margin-top: 0.12rem;
  font-weight: 400;
}
</style>
